import {
 ArrowLeft, BookOpen, Copy
} from 'lucide-react';
import {
 Button
} from 'shared/components/ui/button';
import {
 Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
 useNavigate
} from 'react-router-dom';

// Define type for each blueprint
interface Blueprint {
    id: number;
    name: string;
    description: string;
    tables: number;
}

export function BlueprintsPage() {
    const navigate = useNavigate();

    // Function to handle navigation
    const handleNavigate = (pathname: string) => {
        navigate(`./${pathname}`);
    };

    // Define the blueprints array with proper typing
    const blueprints: Blueprint[] = [
        {
            id: 1,
            name: 'CRM System',
            description: 'Customer relationship management system with contacts, deals, and tasks',
            tables: 5,
        },
        {
            id: 2,
            name: 'Project Management',
            description: 'Track projects, tasks, and team members',
            tables: 4
        },
        {
            id: 3,
            name: 'Inventory Management',
            description: 'Track products, stock levels, and orders',
            tables: 3
        },
    ];

    return (
        <div className="space-y-6 p-4 overflow-y-scroll">
            <div className="flex items-center">
                <Button variant="ghost" className="gap-2" onClick={() => handleNavigate('../../tables')}>
                    <ArrowLeft className="h-4 w-4" />
                    Back to Dashboard
                </Button>
            </div>

            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold">Table Blueprints</h1>
            </div>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {blueprints.map((blueprint) => (
                    <Card key={blueprint.id}>
                        <CardHeader>
                            <CardTitle>{blueprint.name}</CardTitle>
                            <CardDescription>{blueprint.description}</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <div className="flex items-center gap-2">
                                <BookOpen className="h-4 w-4 text-muted-foreground" />
                                <span className="text-sm text-muted-foreground">{blueprint.tables} tables</span>
                            </div>
                        </CardContent>
                        <CardFooter>
                            <Button className="w-full gap-2">
                                <Copy className="h-4 w-4" />
                                Use Blueprint
                            </Button>
                        </CardFooter>
                    </Card>
                ))}

                {/* Placeholder card */}
                <Card className="border-2 border-dashed bg-muted/50">
                    <CardHeader>
                        <CardTitle className="text-muted-foreground">Custom Blueprint</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="h-20 flex items-center justify-center">
                            <p className="text-sm text-muted-foreground">Create your own blueprint</p>
                        </div>
                    </CardContent>
                    <CardFooter>
                        <Button variant="outline" className="w-full">
                            Create Blueprint
                        </Button>
                    </CardFooter>
                </Card>
            </div>
        </div>
    );
}
